
window.loadContry = function () {
    Shopify.formatMoney = function (cents, format) {
        if (typeof cents == "string") {
            cents = cents.replace(".", "");
        }
        var value = "";
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || this.money_format;

        function defaultOption(opt, def) {
            return typeof opt == "undefined" ? def : opt;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ",");
            decimal = defaultOption(decimal, ".");

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split("."),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
                cents = parts[1] ? decimal + parts[1] : "";

            return dollars + cents;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
                value = formatWithDelimiters(cents, 2);
                break;
            case "amount_no_decimals":
                value = formatWithDelimiters(cents, 0);
                break;
            case "amount_with_comma_separator":
                value = formatWithDelimiters(cents, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                value = formatWithDelimiters(cents, 0, ".", ",");
                break;
        }
        return formatString.replace(placeholderRegex, value);
    };
    new Shopify.CountryProvinceSelector(
        "address_country",
        "address_province",
        { hideElement: "address_province_container" }
    );

    const button = document.querySelector("#shipping-calculator .get-rates");
    button.addEventListener('click', function (e) {
        console.log('123');
        cartAddonsSave(e)
    })

    function cartAddonsSave(event) {
        event.preventDefault();
        var e = {};
        (e.zip = document.querySelector("#address_zip").value || ""),
            (e.country = document.querySelector("#address_country").value || ""),
            (e.province = document.querySelector("#address_province").value || ""),
            getCartShippingRatesForDestination(e);
        function getCartShippingRatesForDestination(event) {
            fetch(
                `${window.Shopify.routes.root}cart/shipping_rates.json?shipping_address%5Bzip%5D=${event.zip}&shipping_address%5Bcountry%5D=${event.country}&shipping_address%5Bprovince%5D=${event.province}`
            )
                .then((response) => {
                    return response.text();
                })
                .then((state) => {
                    const message = document.querySelector(".tp__addon-message");
                    for (var item of document.querySelectorAll(".tp__addon-message p")) {
                        item.remove();
                    }
                    const parsedState = JSON.parse(state);
                    console.log(parsedState);
                    if (parsedState && parsedState.shipping_rates) {
                        if (parsedState.shipping_rates.length > 0) {
                            message.classList.remove("error", "warning");
                            message.classList.add("success");
                            const p = document.createElement("p");
                            p.innerText = cartStrings.shipping_rate.replace(
                                "{{address}}",
                                event.zip + ", " + event.country + " " + event.province
                            );
                            message.appendChild(p);
                            parsedState.shipping_rates.map((rate) => {
                                const rateNode = document.createElement("p");
                                rateNode.innerHTML =
                                    rate.name +
                                    ": " +
                                    Shopify.formatMoney(rate.price, cartStrings.money_format);
                                message.appendChild(rateNode);
                            });
                        } else {
                            message.classList.remove("error", "success");
                            message.classList.add("warning");
                            const p = document.createElement("p");
                            p.innerText = cartStrings.no_shipping;
                            message.appendChild(p);
                        }
                    } else {
                        message.classList.remove("success", "warning");
                        message.classList.add("error");
                        Object.entries(parsedState).map((error) => {
                            const message_error = `${error[1][0]}`;
                            const p = document.createElement("p");
                            p.innerText = message_error;
                            message.appendChild(p);
                        });
                    }
                })
                .catch((error) => {
                    throw error;
                });
        }
    }
}

window.loadContry();